import { assign, fromPromise, setup } from "xstate";

import { Logger } from "@moment/logging";

import { tauriApi } from "~/state/api/tauri";

const logger = new Logger("gitConfigMachine");

export const gitConfigMachine = setup({
	types: {
		context: {} as {
			path: string;
			config: Record<string, string | number | null>;
		},
		input: {} as { path: string },
		events: {} as
			| { type: "gitConfig.refetch" }
			| { type: "gitConfig.updateKey"; key: string; value: string | number | null },
	},
	actors: {
		loadConfig: fromPromise<Record<string, string | number | null>, { path: string }>(
			({ input }) => tauriApi.config(input)
		),
		setConfig: fromPromise<
			void,
			{ path: string; newConfig: Record<string, string | number | null> }
		>(({ input }) => tauriApi.configSet(input)),
	},
}).createMachine({
	id: "gitConfig",
	context: ({ input }) => ({
		path: input.path,
		config: {},
	}),
	initial: "loading",
	states: {
		loading: {
			invoke: {
				src: "loadConfig",
				input: ({ context }) => ({ path: context.path }),
				onDone: {
					target: "ready",
					actions: assign(({ event }) => ({
						config: event.output,
					})),
				},
				onError: {
					target: "error",
				},
			},
		},
		ready: {
			initial: "idle",
			states: {
				idle: {},
				persisting: {
					invoke: {
						src: "setConfig",
						input: ({ context }) => ({
							path: context.path,
							newConfig: context.config,
						}),
						onDone: {
							target: "#gitConfig.ready.idle",
						},
						onError: {
							actions: ({ event }) => {
								logger.error("Failed to set git config", {
									error: event.error,
								});
							},
							target: "#gitConfig.error",
						},
					},
				},
			},
		},
		error: {},
	},
	on: {
		"gitConfig.refetch": {
			target: "#gitConfig.loading",
		},
		"gitConfig.updateKey": {
			actions: assign(({ context, event }) => ({
				config: {
					...context.config,
					[event.key]: event.value,
				},
			})),
			target: "#gitConfig.ready.persisting",
		},
	},
});
